<template>
  <TheWorkFormShell v-if="work" :events="work?.events ?? []">
    <RouterView />
  </TheWorkFormShell>
</template>

<script>
import TheWorkFormShell from '@p/works/form/TheWorkFormShell.vue'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheWorkFormNewPage',
  components: { TheWorkFormShell },
  computed: {
    ...mapGetters({
      work: 'work/getWork',
      auth: 'auth/getAuth'
    }),
    auth_role() {
      return this.auth.roles[0]
    }
  },
  methods: {
    ...mapActions({ fetchNewWork: 'work/fetchNewWork' })
  },
  // created() {
  //   this.fetchNewWork()
  // },
  beforeMount() {
    this.fetchNewWork()
  }
}
</script>
